<template lang="pug">
    
article(
    :class="classes"
)
    slot
    
</template>

<script lang="ts">
import Vue, { computed, PropType, useCssModule } from 'vue'

export default Vue.extend({
    name: 'Card',
    props: {
        padding: {
            type: String as PropType<'blue' | 'orange'>,
        },
        radius: {
            type: String as PropType<'xl' | 'm'>,
        },
        radiusSide: {
            type: String as PropType<'all' | 'bottom'>,
            default: 'all',
        },
    },
    setup(props) {
        const styles = useCssModule()

        const classes = computed(() => [
            styles.root,
            styles[`padding_${props.padding}`],
            styles[`radius_${props.radius}`],
        ])

        return {
            classes,
        }
    },
})
</script>

<style module lang="scss">
.root {
    border-radius: var(--card-xl, rem(24));
    display: flex;
    flex-direction: column;
    background-color: var(--bg, #fff);
    box-sizing: border-box;
}

.padding {
    &_blue {
        padding: var(--blue, rem(32));
    }

    &_orange {
        padding: var(--orange, rem(16));
    }
}

.radius {
    &_xl {
        border-radius: var(--card-xl, rem(24));
    }
    &_m {
        border-radius: var(--card-m, rem(16));
    }
}
</style>
